module.exports = __webpack_public_path__ + "img/logo2.80b2d168.png";